import {createSlice} from '@reduxjs/toolkit'

// ** UseJWT import to get config
import useJwt from '@src/auth/jwt/useJwt'

const config = useJwt.jwtConfig

const initialUser = () => {
    const item = window.localStorage.getItem('userData')
    //** Parse stored json or if none return initialValue
    return item ? JSON.parse(item) : {}
}

export const authSlice = createSlice({
    name: 'authentication',
    initialState: {
        userData: initialUser()
    },
    reducers: {
        handleLogin: (state, action) => {
            state[config.storageTokenKeyName] = action.payload[config.storageTokenKeyName]
            state[config.storageRefreshTokenKeyName] = action.payload[config.storageRefreshTokenKeyName]
            localStorage.setItem(config.storageTokenKeyName, JSON.stringify(action.payload.accessToken))
            localStorage.setItem(config.storageRefreshTokenKeyName, JSON.stringify(action.payload.refreshToken))
        },
        handleLogout: state => {
            state.userData = {}
            state[config.storageTokenKeyName] = null
            state[config.storageRefreshTokenKeyName] = null
            localStorage.removeItem('userData')
            localStorage.removeItem(config.storageTokenKeyName)
            localStorage.removeItem(config.storageRefreshTokenKeyName)
        },
        handleGetAbilities: (state, action) => {
            state.userData = action.payload
            localStorage.setItem('userData', JSON.stringify(action.payload))
        },
        handleGetActToken: (state, action) => {
            localStorage.removeItem('userData')
            localStorage.removeItem(config.storageTokenKeyName)
            localStorage.removeItem(config.storageRefreshTokenKeyName)
            state[config.storageTokenKeyName] = action.payload[config.storageTokenKeyName]
            state[config.storageRefreshTokenKeyName] = action.payload[config.storageTokenKeyName]
            localStorage.setItem(config.storageTokenKeyName, JSON.stringify(action.payload.accessToken))
            localStorage.setItem(config.storageRefreshTokenKeyName, JSON.stringify(action.payload.accessToken))
        },
        handleReturnToMain: (state, action) => {
            localStorage.removeItem('userData')
            localStorage.removeItem(config.storageTokenKeyName)
            localStorage.removeItem(config.storageRefreshTokenKeyName)
            state[config.storageTokenKeyName] = action.payload[config.storageTokenKeyName]
            state[config.storageRefreshTokenKeyName] = action.payload[config.storageTokenKeyName]
            localStorage.setItem(config.storageTokenKeyName, JSON.stringify(action.payload.accessToken))
            localStorage.setItem(config.storageRefreshTokenKeyName, JSON.stringify(action.payload.accessToken))
        }
    }
})

export const {handleLogin, handleLogout, handleGetAbilities, handleGetActToken, handleReturnToMain} = authSlice.actions

export default authSlice.reducer
